<template>
  <p class="text-secondary text-small font-italic text-left">
    {{ $t("ui-measured-last-text") }} {{ lastUpdatedAt }}.
    {{ $t("ui-measured-update-text") }}
  </p>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  name: "last-measured",
  computed: {
    ...mapGetters({
      lastUpdatedAt: "users/getSelfLastUpdated"
    })
  }
};
</script>
<style scoped>
.text-small {
  font-size: smaller;
}
</style>
